import Clickable from "../Clickable";
import Icon from "../Icon";
import NamurIcon from "../NamurIcon";
import StatusBadge from "../StatusBadge";
import { Chips } from "../Chips";

type OwnProps = {
  actions?: React.ReactNode;
  description?: string | React.ReactNode;
  disabled?: boolean;
  id?: string;
  icon?: string;
  iconPrimary?: boolean;
  image?: React.ReactNode;
  imageUrl?: string;
  namur?: string;
  onClick?: $TSFixMeFunction;
  showDisclosureIndicator?: boolean;
  status?: string;
  target?: string;
  title?: string | React.ReactNode;
  value?: string | React.ReactNode;
  className?: string;
  specifications?: {
    id?: string;
    name?: string;
  }[];
  nodes?: {
    id?: string;
    name?: string;
  }[];
  extraContent?: React.ReactNode;
  onAuxClick?: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  actions: undefined,
  description: undefined,
  disabled: false,
  icon: undefined,
  iconPrimary: false,
  image: undefined,
  imageUrl: undefined,
  namur: undefined,
  onClick: undefined,
  showDisclosureIndicator: false,
  status: undefined,
  target: undefined,
  title: undefined,
  value: undefined,
  className: "",
};

type Props = OwnProps & typeof defaultProps;

function ListItem({
  actions,
  description,
  disabled,
  icon,
  iconPrimary,
  id,
  image,
  imageUrl,
  namur,
  onClick,
  showDisclosureIndicator,
  status,
  target,
  title,
  value,
  className,
  specifications,
  nodes,
  extraContent,
  onAuxClick,
}: Props) {
  const classSubstring = icon ? "icon" : "image";
  const customClassName = className ? ` ${className}` : "";
  const statusElements = (
    <>
      {status && (
        <div className={`list-item-${classSubstring}-status`}>
          <StatusBadge name={status} />
        </div>
      )}
      {namur && (
        <div className={`list-item-${classSubstring}-namur`}>
          <NamurIcon type={namur} size={15} />
        </div>
      )}
    </>
  );

  const statusElementFromUrl = imageUrl ? (
    <div className="list-item-image">
      <div
        className="list-item-image-image"
        style={{ backgroundImage: `url(${imageUrl})` }}
      />
      {statusElements}
    </div>
  ) : null;

  const statusElementFromImage = image ? (
    <div className="list-item-image">
      {image}
      {statusElements}
    </div>
  ) : null;

  const statusElementFromIcon = icon ? (
    <div className={`list-item-icon${iconPrimary ? " primary" : ""}`}>
      <Icon name={icon} />
      {statusElements}
    </div>
  ) : null;

  const content = (
    <div className="list-item-content">
      <div className="list-item-content-wrapper">
        <div className="list-item-content-title">{title}</div>
        <div className="list-item-content-description">{description}</div>
        {specifications && (
          <div className="list-item-chip">
            <Icon name="icon3-eh-list chip-icon" />
            {/* @ts-expect-error TS(2322) FIXME: Type '{ id?: string | undefined; name?: string | u... Remove this comment to see the full error message */}
            <Chips items={specifications} withTooltip />
          </div>
        )}
        {nodes && (
          <div className="list-item-chip">
            <Icon name="icon3-eh-folder chip-icon" />
            {/* @ts-expect-error TS(2322) FIXME: Type '{ id?: string | undefined; name?: string | u... Remove this comment to see the full error message */}
            <Chips items={nodes} withTooltip />
          </div>
        )}
      </div>
      {value ? <div className="list-item-content-value">{value}</div> : null}
    </div>
  );

  return (
    <div
      data-testid={id}
      id={id}
      className={`list-item${disabled ? " disabled" : ""}${customClassName}`}
    >
      <Clickable
        target={target}
        // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | null | undefined' is not ... Remove this comment to see the full error message
        onClick={!disabled ? onClick : null}
        // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | null | undefined' is not ... Remove this comment to see the full error message
        onAuxClick={!disabled ? onAuxClick : null}
        outside
      >
        {statusElementFromUrl}
        {statusElementFromImage}
        {statusElementFromIcon}
        {content}
      </Clickable>
      {actions || showDisclosureIndicator ? (
        <div className="list-item-actions">
          {showDisclosureIndicator ? <Icon name="icon-eh-arrow-right" /> : null}
          {actions}
        </div>
      ) : null}
      {extraContent}
    </div>
  );
}

ListItem.defaultProps = defaultProps;

export default ListItem;
